var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71429 0C1.66562 0 0 1.66562 0 3.71429V22.2857C0 24.3344 1.66562 26 3.71429 26H22.2857C24.3344 26 26 24.3344 26 22.2857V3.71429C26 1.66562 24.3344 0 22.2857 0H3.71429ZM6.96429 11.1429C7.73616 11.1429 8.35714 11.7638 8.35714 12.5357V19.0357C8.35714 19.8076 7.73616 20.4286 6.96429 20.4286C6.19241 20.4286 5.57143 19.8076 5.57143 19.0357V12.5357C5.57143 11.7638 6.19241 11.1429 6.96429 11.1429ZM17.6429 16.25C17.6429 15.4781 18.2638 14.8571 19.0357 14.8571C19.8076 14.8571 20.4286 15.4781 20.4286 16.25V19.0357C20.4286 19.8076 19.8076 20.4286 19.0357 20.4286C18.2638 20.4286 17.6429 19.8076 17.6429 19.0357V16.25ZM13 5.57143C13.7719 5.57143 14.3929 6.19241 14.3929 6.96429V19.0357C14.3929 19.8076 13.7719 20.4286 13 20.4286C12.2281 20.4286 11.6071 19.8076 11.6071 19.0357V6.96429C11.6071 6.19241 12.2281 5.57143 13 5.57143Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash2);
export default __webpack_public_path__ + "static/media/dash2.926cef031c037a51acadc0088f8f6c53.svg";
export { ForwardRef as ReactComponent };